import { render, staticRenderFns } from "./TextoCorreoEditor.vue?vue&type=template&id=12085a20&scoped=true"
import script from "./TextoCorreoEditor.vue?vue&type=script&lang=js"
export * from "./TextoCorreoEditor.vue?vue&type=script&lang=js"
import style0 from "./TextoCorreoEditor.vue?vue&type=style&index=0&id=12085a20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12085a20",
  null
  
)

export default component.exports